import { EntityMention } from "./entity-mention";
import { suggestion } from "./suggestion";

export const mention = ({
  accessToken,
  siteSlug,
  subdomain,
}: {
  accessToken: string | undefined;
  siteSlug?: string | undefined;
  subdomain: string;
}) =>
  EntityMention.configure({
    accessToken,
    siteSlug,
    subdomain,
    suggestion: suggestion({ accessToken, siteSlug, subdomain }),
  });

export const mentionReadonly = EntityMention.configure({ link: true });
